<template>
    <div v-if="visible" class="beta-badge">
        <span class="beta-badge-label">BETA</span>
        <button-tooltip
            :tooltip="$t('common.beta_hide_for_today')"
            button-class="beta-badge-close"
            icon x-small top
            @click="hide">
            <v-icon size="14" color="#0C0E12">mdi-close</v-icon>
        </button-tooltip>
    </div>
</template>

<script>
import ButtonTooltip from '@/components/common/ButtonTooltip'

const HIDE_KEY = 'beta.badge.hidden'

export default {
    name: 'BetaBadge',
    components: { ButtonTooltip },
    data() {
        return {
            hidden: false,
        }
    },
    computed: {
        visible(vm = this) {
            return process.env.VUE_APP_BETA === 'true' && !vm.hidden
        },
    },
    created() {
        const vm = this
        try {
            const params = new URLSearchParams(window.location.search)
            if (params.get('beta') === 'show') return
            vm.hidden = window.localStorage.getItem(HIDE_KEY) === vm.today()
        } catch (e) {
            vm.hidden = false
        }
    },
    methods: {
        today() {
            return this.$moment().format('YYYY-MM-DD')
        },
        hide() {
            const vm = this
            try {
                window.localStorage.setItem(HIDE_KEY, vm.today())
            } catch (e) { /* localStorage unavailable */ }
            vm.hidden = true
        },
    },
}
</script>

<style scoped>
.beta-badge {
    position: fixed;
    right: 16px;
    bottom: calc(16px + var(--safe-area-inset-bottom, 0px));
    z-index: 300;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 4px 4px 12px;
    border-radius: 999px;
    background: var(--brand-gradient);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    pointer-events: none;
}

.beta-badge-label {
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.14em;
    color: #0C0E12;
}

.beta-badge >>> .beta-badge-close {
    pointer-events: auto;
    color: #0C0E12 !important;
}

.beta-badge >>> .beta-badge-close::before {
    background-color: #0C0E12;
}
</style>
